import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
require('esri-leaflet');
import * as esri_geo from 'esri-leaflet-geocoder';

//Map
var L = require('leaflet');
var map = L.map('map',{scrollWheelZoom: false}).setView([51.505, -0.09], 13);
var osmUrl = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
osmAttribution = 'Map data &copy; 2012 <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
osm = new L.TileLayer(osmUrl, {maxZoom: 18, attribution: osmAttribution});
map.setView(new L.LatLng(14.64095000, -90.61329000), 12).addLayer(osm);
var origin   = window.location.origin;

var iconoEdificio = L.icon({
    iconUrl: '/images/marker3.png',
    iconSize:     [56, 66], // size of the icon
    //shadowSize:   [50, 64], // size of the shadow
    iconAnchor:   [24, 24], // point of the icon which will correspond to marker's location
    //shadowAnchor: [24, 24],  // the same for the shadow
    popupAnchor:  [1, -20]
});

var iconoCasa = L.icon({
    iconUrl: '/images/marker4.png',
    iconSize:     [56, 66], // size of the icon
    //shadowSize:   [50, 64], // size of the shadow
    iconAnchor:   [24, 24], // point of the icon which will correspond to marker's location
    //shadowAnchor: [24, 24],  // the same for the shadow
    popupAnchor:  [1, -20]
});


var csrf = $('meta[name="csrf-token"]').attr('content');

function addControlPlaceholders(map) {
    var corners = map._controlCorners,
        l = 'leaflet-',
        container = map._controlContainer;

    function createCorner(vSide, hSide) {
        var className = l + vSide + ' ' + l + hSide;

        corners[vSide + hSide] = L.DomUtil.create('div', className, container);
    }

    createCorner('verticalcenter', 'left');
    createCorner('verticalcenter', 'right');
}
addControlPlaceholders(map);

// Change the position of the Zoom Control to a newly created placeholder.
map.zoomControl.setPosition('verticalcenterleft');


var onMarkerClick = function(e){
    $("#inmuebleNombre").text(this.options.Nombre);
    $("#inmueble").val(this.options.IdInmueble);
    $("#precio").text("Desde: $"+this.options.Precio);
    $("#metros").text(this.options.Metros + " Metros cuadrados");
    $("#habitaciones").text(this.options.Habitacion + " Habitaciones");
    $("#observaciones").text(this.options.Observaciones);
    $("#aplicar").css('visibility', 'visible');
    $.get(this.options.img)
    .done(function() {$("#imgInmueble").attr("src",this.options.img);    
    }).fail(function() {$("#imgInmueble").attr("src","/images/casaDefault.jpg");})
    $("#map").css('height','600px');
    $("#busqueda").show();
    $("#Inmueble-child").show();
    //$("#tour-childs-detalle").show();
    $("#carousel-childs-detalle").hide();
    $("#childs-detalle").show();
    showChildDetails(this.options.IdInmueble, 0);
    $("#calculadora-hipotecaria").show();
    $("#footer").show();

    $(".overlayMap").css('bottom','auto');

    enableScroll();

    map.flyTo(this.getLatLng(),16);
    //console.log("OnMarketClick");
    //map.flyTo([this.options.Latitud, this.options.Longitud],16)
    //$("#carousel").show();

}

var onParentMarkerClick = function(e){
    $("#inmuebleNombre").text(this.options.NombrePadre);
    $("#observaciones").text(this.options.observaciones);
    $("#imgInmueble").attr("src",this.options.img);

     $("#map").css('height','600px');
     $("#busqueda").show();
     $("#Inmueble-child").hide();
     $("#footer").show();
     $("#carousel-childs").show();
     $("#aplicar").css('visibility', 'visible');
     $(".overlayMap").css('bottom','auto');

    enableScroll();
    map.flyTo(this.getLatLng(),16);
    //console.log("onParentMarkerClick");

  //  var $jQueryObject = $($.parseHTML(this.options.carouselChild));
  //  $("#carousel-childs").html($jQueryObject.find("#carousel-child-main").html());

    $("#carousel-childs").append($.parseHTML(this.options.carouselChild));

    //console.log(this.options.childs);

    }


var onMarkerLeft = function(e){

    $("#map").css('height','1080px');
    $("#busqueda").hide();
    $("#carousel-childs-detalle").hide();
    $("#Inmueble-child").hide();
    $("#childs-detalle").hide();
    $("#carousel-childs").hide();
    $("#calculadora-hipotecaria").hide();
    $("#footer").hide();
    $(".overlayMap").css('bottom','600px');
    $("#aplicar").css('visibility', 'visible');
    disableScroll();

    $("#carousel-childs").empty();

    //console.log("onMarkerLeft");

}

function disableScroll() {
    document.body.classList.add("stop-scrolling");
}

function enableScroll() {
    document.body.classList.remove("stop-scrolling");
    document.body.classList.add("stop-scrolling_x");
}

var maxP = getUrlVars()["maxP"];
var minP = getUrlVars()["minP"];
var maxA = getUrlVars()["maxA"];
var minA = getUrlVars()["minA"];
var habitacion = getUrlVars()["habitacion"];
var banio = getUrlVars()["banio"];
var parqueo = getUrlVars()["parqueo"];
var direccion = decodeURIComponent(getUrlVars()["direccion"]);
var departamento = getUrlVars()["departamento"];
var municipio = getUrlVars()["municipio"];
var transaccion = getUrlVars()["transaccion"];
var zona = getUrlVars()["zona"];
var tipo = getUrlVars()["tipo"];
var inmueble = getUrlVars()["inmueble"];

direccion = decodeURI(direccion);

if (!habitacion) {
    habitacion=0
}

if (!banio) {
    banio=0
}

if (!parqueo) {
    parqueo=0
}

if (!transaccion) {
    transaccion=0
}


if(!inmueble){
    $.ajax({
        url: "/inmueble/coordenadas",
        type: "POST",
        data:{
            _token:csrf,
            maxP:maxP,
            minP:minP,
            maxA:maxA,
            minA:minA,
            habitacion:habitacion,
            banio:banio,
            parqueo:parqueo,
            direccion:direccion,
            departamento:departamento,
            municipio:municipio,
            transaccion:transaccion,
            zona:zona,
            tipo:tipo,
            inmueble:inmueble
        },
        //cache: false,
        dataType: 'json',
        success: function(dataResult){
            var resultData = dataResult.data;

            //console.log(resultData);

            var base_url = window.location.origin;

            var inmuebles_Child = getInmueblesChilds(resultData, transaccion, tipo);

            var ids_Parents = inmuebles_Child.map(function(obj) {
                return obj.Id_Inmueble_Padre;
              });

              //console.log("ids_Parents");
              //console.log(ids_Parents);

              var inmuebles_Parent_Filter = ids_Parents.filter(function(item, index) {
                if (ids_Parents.indexOf(item) == index)
                  return item;
              });

              //console.log("Inmuebles_Parent_Filter...");
            //console.log(inmuebles_Parent_Filter);


              var inmuebles_Parent = getInmueblesParents(inmuebles_Parent_Filter);

           // console.log("Inmuebles_Parent...");
            //console.log(inmuebles_Parent);

            var inmuebles_No_Child = resultData.filter(function (e) {
                return e.Id_Inmueble_Padre == null || e.Id_Inmueble_Padre == undefined
            });

            //var inmuebles_Parent = resultData.filter((inmueble) => ids_Padres.includes(inmueble.Id_Inmueble));

            var inmuebles_No_Parent_No_Child = inmuebles_No_Child.filter(item => !inmuebles_Parent.includes(item));

            //var inmuebles_Has_Child = hasChild()

            if(inmuebles_No_Parent_No_Child.length > 0){
                addNoParentNoChild(inmuebles_No_Parent_No_Child);
            }

            if(inmuebles_Parent.length > 0 && inmuebles_Child.length > 0){
                addParentAndChild(inmuebles_Parent,inmuebles_Child);
            }

            //console.log("inmuebles_Child");
            //console.log(inmuebles_Child);
            // console.log("inmuebles_No_Child");
            // console.log(inmuebles_No_Child);
             //console.log("inmuebles_Parent");
           //  console.log(inmuebles_Parent);
            // console.log("inmuebles_No_Parent_No_Child");
            // console.log(inmuebles_No_Parent_No_Child);
        }
    });
}
else{
    $.ajax({
        url: "/inmueble/coordenadasSingle",
        type: "POST",
        data:{
            _token:csrf,
            inmueble:inmueble
        },
        //cache: false,
        dataType: 'json',
        success: function(dataResult){
            var resultData = dataResult.data;

            //console.log(resultData);

            var base_url = window.location.origin;

            var inmuebles_Child = resultData;
            //var inmuebles_Child = getInmueblesChilds(resultData, transaccion, tipo);

            var ids_Parents = inmuebles_Child.map(function(obj) {
                return obj.Id_Inmueble_Padre;
              });

              //console.log("ids_Parents");
              //console.log(ids_Parents);

              var inmuebles_Parent_Filter = ids_Parents.filter(function(item, index) {
                if (ids_Parents.indexOf(item) == index)
                  return item;
              });

              //console.log("Inmuebles_Parent_Filter...");
            //console.log(inmuebles_Parent_Filter);


              var inmuebles_Parent = getInmueblesParents(inmuebles_Parent_Filter);

           // console.log("Inmuebles_Parent...");
            //console.log(inmuebles_Parent);

            var inmuebles_No_Child = resultData.filter(function (e) {
                return e.Id_Inmueble_Padre == null || e.Id_Inmueble_Padre == undefined
            });

            //var inmuebles_Parent = resultData.filter((inmueble) => ids_Padres.includes(inmueble.Id_Inmueble));

            var inmuebles_No_Parent_No_Child = inmuebles_No_Child.filter(item => !inmuebles_Parent.includes(item));

            //var inmuebles_Has_Child = hasChild()

            if(inmuebles_No_Parent_No_Child.length > 0){
                addNoParentNoChild(inmuebles_No_Parent_No_Child);
            }

            if(inmuebles_Parent.length > 0 && inmuebles_Child.length > 0){
                addParentAndChild(inmuebles_Parent,inmuebles_Child);
            }

            //console.log("inmuebles_Child");
            //console.log(inmuebles_Child);
             //console.log("inmuebles_No_Child");
             //console.log(inmuebles_No_Child);
             //console.log("inmuebles_Parent");
             //console.log(inmuebles_Parent);
             //console.log("inmuebles_No_Parent_No_Child");
             //console.log(inmuebles_No_Parent_No_Child);
        }
    });
}


function getUrlVars()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
}

function getInmueble(Inmueble){

    //var childs = new Object();
    var childs;

    var ids = $.map(Inmuebles, function(Inmueble) {
        return Inmueble.Id_Inmueble;
    });

    var Ids_Inmuebles = JSON.stringify(ids);

    $.ajax({
        async: false,
        url: "/inmueble/obtener",
        type: "POST",
        data:{
            _token:csrf,
            Id_Inmueble:Ids_Inmuebles
        },
        dataType: 'json',
        success: function(dataResult){
            //var resultData = dataResult.data;
            childs = dataResult.data;
            //console.log(childs);
        }
    });

    return childs;
}

function getInmueblesChilds(Inmuebles,Transaccion,Tipo){

    //var childs = new Object();
    var childs;

    var ids = $.map(Inmuebles, function(Inmueble) {
        return Inmueble.Id_Inmueble;
    });

    var Ids_Inmuebles = JSON.stringify(ids);

    $.ajax({
        async: false,
        url: "/inmueble/hijos",
        type: "POST",
        data:{
            _token:csrf,
            Ids_Inmuebles:Ids_Inmuebles,
            Transaccion:Transaccion,
            Tipo:Tipo
        },
        dataType: 'json',
        success: function(dataResult){
            //var resultData = dataResult.data;
            childs = dataResult.data;
            //console.log(childs);
        }
    });

    return childs;
}

function getInmueblesParents(Inmuebles){

    //var childs = new Object();
    var parents;

    // var ids = $.map(Inmuebles, function(Inmueble) {
    //     return Inmueble.Id_Inmueble;
    // });

    var Ids_Inmuebles = JSON.stringify(Inmuebles);

    $.ajax({
        async: false,
        url: "/inmueble/padres",
        type: "POST",
        data:{
            _token:csrf,
            Ids_Inmuebles:Ids_Inmuebles
        },
        dataType: 'json',
        success: function(dataResult){
            //var resultData = dataResult.data;
            parents = dataResult.data;
            //console.log(childs);
        }
    });

    return parents;
}

function addNoParentNoChild(inmuebles_No_Parent_No_Child){

    map.flyTo([inmuebles_No_Parent_No_Child[0].inmueble_detalles[0].Latitud, inmuebles_No_Parent_No_Child[0].inmueble_detalles[0].Longitud], 16);

    $.each(inmuebles_No_Parent_No_Child,function(index){
      if(inmuebles_No_Parent_No_Child[index].Id_Tipo_Inmueble != 4){
        try {
            var img = origin+"/inmuebles/i_"+inmuebles_No_Parent_No_Child[index].Id_Inmueble+"/"+inmuebles_No_Parent_No_Child[index].inmueble_det_archivos[0].Archivo;

          }
        catch(err) {
            var img = origin+"/images/casaDefault.jpg";
          }

            $.each(inmuebles_No_Parent_No_Child[index].inmueble_detalles,function(detalle){

                if(inmuebles_No_Parent_No_Child[index].Id_Tipo_Inmueble == 3)
                {
                    var icono = iconoEdificio;
                }
                else
                {
                    var icono = iconoCasa;
                }

                var precio = parseFloat(inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Precio_Renta)+parseFloat(inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Precio_Venta);
                let strObservaciones = String(inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Observaciones);
                let strobs = strObservaciones.length > 100 ? strObservaciones.substr(0,200) + "..." : strObservaciones;
                var marker = new L.marker([inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Latitud,
                    inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Longitud],
                                          {Nombre:inmuebles_No_Parent_No_Child[index].Nombre,
                                            IdInmueble: inmuebles_No_Parent_No_Child[index].Id_Inmueble,
                                           IdDetalle: inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Id_Inmueble_Detalle,
                                           Precio:precio,
                                           Metros:inmuebles_No_Parent_No_Child[index].Ancho*inmuebles_No_Parent_No_Child[index].Largo,
                                           Habitacion:inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].No_Habitaciones,
                                           Observaciones:inmuebles_No_Parent_No_Child[index].inmueble_detalles[detalle].Observaciones,
                                           icon: icono,
                                            img:img})
                    .bindPopup("<div class='card border-0'>"+
                    "<div class='card-body'>"+
                    //"<img alt='100%x280' style='height: 250px;width: 260px;' src='"+ url +"'>"+
                    "<img class ='card-img-top-parent' style='height: 125px;  width: 100%;' alt='100%x280' src='"+img+"' onerror='ImgError(this);'/>"+
                    "</br></br><h5 class='card-title tipoLetraCardLabelH2' style='color:#BBD400'; font-weight:'bolder;'>"+inmuebles_No_Parent_No_Child[index].Nombre+"</h5>"+
                    "<div class='amenidades'>"+
                    // "<i class='fa fa-swimming-pool icon' aria-hidden='true' style='display: inline-block;></i>"+
                    // "<i class='fa fa-dumbbell icon' aria-hidden='true' style='display: inline-block;></i>"+
                    // "<i class='fa fa-paw icon' aria-hidden='true' style='display: inline-block;'></i>"+
                    "</div>"+
                    "<div>"+
                    "<p class='card-text'>"+
                    strobs+
                    "</p>"+
                    "</div>"+
                    "</div>"+
                    "</div>"+
                    "</div>")

                    .on('click', onMarkerClick)
                    .on('popupclose',onMarkerLeft)
                    .addTo(map);
            })
        }
    });
}

function addParentAndChild(inmuebles_Parent, inmuebles_Child){
    map.flyTo([inmuebles_Parent[0].inmueble_detalles[0].Latitud, inmuebles_Parent[0].inmueble_detalles[0].Longitud], 16);

    $.each(inmuebles_Parent,function(index){

        var childs = inmuebles_Child.filter(function (e) {
            return e.Id_Inmueble_Padre == inmuebles_Parent[index].Id_Inmueble;
        });

        var html = "";
        var htmlCarouselChild = "";
        var carouselChild = "";
        var child ="";
        var itemNumber = 1;

        try {
            var img = origin+"/inmuebles/i_"+inmuebles_Parent[index].Id_Inmueble+"/"+inmuebles_Parent[index].inmueble_det_archivos[0].Archivo;

          }
        catch(err) {
            var img = origin+"/images/edificioDefault.jpg";
            //console.log(err);
          }

            // $.each(resultData[index].inmueble_detalles,function(detalle){

        if(inmuebles_Parent[index].Id_Tipo_Inmueble == 3 || inmuebles_Parent[index].Id_Tipo_Inmueble == 4 || inmuebles_Parent[index].Id_Tipo_Inmueble == 5 ){
            var icono = iconoEdificio;
        }
        else{
            var icono = iconoCasa;
        }

        $.each(childs,function(index){

            try {
                var childImg = origin+"/inmuebles/i_"+childs[index].Id_Inmueble+"/"+childs[index].inmueble_det_archivos[0].Archivo;
              }
            catch(err) {
                var childImg = origin+"/images/edificioDefault.jpg";
                //console.log(err);
              }


            var item ="";
            var carouselChildItemsStart ="";
            var carouselChildItemsEnd ="";
            var isLastElement = index == childs.length -1;


            if(childs[index].inmueble_detalles.length > 0 ){
                var observaciones = childs[index].inmueble_detalles[0].Observaciones ? childs[index].inmueble_detalles[0].Observaciones : '';
                //console.log(childs[index].Id_Inmueble + "-" + childs[index].inmueble_detalles[0].Observaciones);
            }
            else{
                var observaciones = "";
            }


            if(index == 0){
                item = "<div class='carousel-item active'>"
            }
            else{
                item = "<div class='carousel-item'>";
            }

            if(itemNumber == 1 && index == 0){
                carouselChildItemsStart ="<div class='carousel-item active'><div class='row'>";
            }
            else{
                 carouselChildItemsStart ="";
            }

            if(itemNumber == 1 && index != 0){
                carouselChildItemsStart = "<div class='carousel-item'><div class='row'>";
            }

            if(itemNumber == 3 || isLastElement ){
                carouselChildItemsEnd ="</div>"+
                                    "</div>";
                itemNumber = 0;
            }
            
            //Ajuste de Observaciones con texto mayor a 200 caracteres
            const newobs = observaciones.length >= 200 ? observaciones.substr(0,200) + "..." : observaciones;

            child = child + item +
            "<div class='row'>"+
                "<div class='col-md-12'>"+
                    "<div class='card border-0'>"+
                        "<img class ='card-img-top-parent' style='height: 125px; width: 260px;' alt='100%x280' src='"+childImg+"'onerror='ImgError(this,2);'/>"+
                        "<input type='hidden' id='Id_Inmueble_Card' value='"+childs[index].Id_Inmueble+"'></input>"+
                        "<div class='card-body card-body-tamanio-inmueble' style='width: 260px; height:250px'>"+
                            "<h6 class='card-title tipoLetraCardLabelH2' style='color:#BBD400; font-weight:bolder; height: 25px'>"+childs[index].Nombre+"</h6>"+
                            "<div class='scrollable-forms'>"+
                            "<p class='card-text tipoLetraCardInput' style='text-align: justify;'>"+
                            newobs+
                            ".</p>"+
                            "</div></br></br>"+
                            "<div class='col-md-12 d-flex justify-content-center'>"+
                                "<button class='btn btn-success btn-forms shadow btnDetalle tipoLetraButton'  id='"+childs[index].Id_Inmueble+"' type='button' onclick='showChildDetails("+childs[index].Id_Inmueble+",1);'>Ver detalle</button>"+
                            "</div>"+
                        "</div>"+
                    "</div>"+
                "</div>"+
            "</div>"+
        "</div>";



        carouselChild = carouselChild + carouselChildItemsStart + "<div class='resize col-1 col-sm-4 col-md-4 col-lg-4 col-xl-4'>"+
        "<div class='card border-0'>"+
            "<img class ='card-img-top-child' style='height: 125px; width: 260px;' alt='100%x280' src='"+childImg+"'onerror='ImgError(this,2);'/>"+
            "<input type='hidden' id='Id_Inmueble_Card' value='"+childs[index].Id_Inmueble+"'></input>"+
            "<div class='card-body card-body-tamanio-inmueble' style='width: 260px; height:250px'>"+
                "<h6 class='card-title tipoLetraCardLabelH2' style='color:#BBD400; font-weight:bolder; height: 25px'>"+childs[index].Nombre+"</h6>"+
                "<div class='scrollable-forms card-text-tamanio-inmueble'>"+
                "<p class='card-text tipoLetraCardInput'>"+
                newobs+
                //childs[index].inmueble_detalles[0].Observaciones+
                ".</p>"+
                "</div></br>"+
                "<div class='col-md-12 pt-2 d-flex justify-content-center'>"+
                    "<button class='btn btn-success btn-forms shadow btnDetalle tipoLetraButton'  id='"+childs[index].Id_Inmueble+"' type='button' onclick='showChildDetails("+childs[index].Id_Inmueble+",1);'>Ver detalle</button>"+
                "</div>"+
            "</div>"+
        "</div>"+
    "</div>"+
    carouselChildItemsEnd;
itemNumber++;

});

html= "<section>"+
        "<div class='container'>"+
            "<div class='row'>"+
                "<div class='col-6'>"+
                    "<h3 class='mb-3'>"+
                    "</h3>"+
                "</div>"+
                "<div class='col-12'>"+
                    "<div id='carouselExampleIndicators2' class='carousel slide' data-ride='carousel'>"+
                    "<div class='carousel-inner'>"+
                        child+
                    "</div>";

                    if (childs.length>1){
                        html=html+"<a class='carousel-control-prev' href='#carouselExampleIndicators2' role='button' data-slide='prev'>"+
                        "<span class='fa fa-chevron-left fa-4x icon' aria-hidden='true'></span>"+
                        "<span class='sr-only'>Previous</span>"+
                        "</a>"+
                        "<a class='carousel-control-next' href='#carouselExampleIndicators2' role='button' data-slide='next'>"+
                        "<span class='fa fa-chevron-right fa-4x icon' aria-hidden='true'></span>"+
                        "<span class='sr-only'>Next</span>"+
                        "</a>";
                    }

                   html=html+"</div>"+
                "</div>"+
            "</div>"+
          "</div>"+
        "</section>";

        htmlCarouselChild= "<section id='carousel-child-main'>"+
        "<div class='container'>"+
            "<div class='row'>"+
                "<div class='col-6'>"+
                    "<h3 class='mb-3'>"+
                    "</h3>"+
                "</div>"+
                "<div class='col-12'>"+
                    "<div id='carousel-child' class='carousel slide style-carousel-child' data-ride='carousel'>"+
                    "<div class='carousel-inner'>"+
                        //"<div class='carousel-item active'>"+
                        //    "<div class='row'>"+
                                carouselChild+
                        //    "</div>"+
                        //"</div>"+
                    "</div>";

                    if (childs.length>3){
                        htmlCarouselChild=htmlCarouselChild+"<a class='carousel-control-prev' href='#carousel-child' role='button' data-slide='prev'>"+
                        "<span class='fa fa-chevron-left fa-2x icon' aria-hidden='true'></span>"+
                        "<span class='sr-only'>Previous</span>"+
                        "</a>"+
                        "<a class='carousel-control-next' href='#carousel-child' role='button' data-slide='next'>"+
                        "<span class='fa fa-chevron-right fa-2x icon' aria-hidden='true'></span>"+
                        "<span class='sr-only'>Next</span>"+
                        "</a>";
                    }

                    htmlCarouselChild=htmlCarouselChild+
                    "</div>"+
                "</div>"+
            "</div>"+
          "</div>"+
        "</section>"+
        "</br>"+
        "</br>";

            //console.log(html);
            //console.log(htmlCarouselChild);

            if(inmuebles_Parent[index].inmueble_detalles.length > 0 ){
                var observacionesParent = inmuebles_Parent[index].inmueble_detalles[0].Observaciones ? inmuebles_Parent[index].inmueble_detalles[0].Observaciones : '';
                //console.log(childs[index].Id_Inmueble + "-" + childs[index].inmueble_detalles[0].Observaciones);
            }
            else{
                var observacionesParent = "";
            }

        var marker = new L.marker([inmuebles_Parent[index].Latitud,
                                   inmuebles_Parent[index].Longitud],

                                   {   NombrePadre:inmuebles_Parent[index].Nombre,
                                       observaciones:observacionesParent,
                                       carouselChild:htmlCarouselChild,
                                       childs:childs,
                                       icon: icono,
                                       img:img
                                    })
                        .bindPopup(html,{maxWidth : 340})

                     .on('click', onParentMarkerClick)
                     .on('popupclose',onMarkerLeft)
                     .addTo(map);

            // })

    });
}
